module.exports = __webpack_public_path__ + "static/media/ike95.dd206008.png";